import { Box, Typography } from '@mui/material';
import { colors, mono } from '../themes/theme';
import { formatTokens } from '../lib/format';

interface TokenBadgeProps {
    balance: number;
    label?: string;
    eliminated?: boolean;
}

export function TokenBadge({ balance, label = 'Balance', eliminated = false }: TokenBadgeProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 0.25,
                // Never squeezed by a long hangout name beside it, and never
                // broken mid-number.
                flexShrink: 0,
                whiteSpace: 'nowrap',
                alignItems: 'flex-end',
            }}
        >
            <Typography variant="overline" sx={{ color: colors.muted, whiteSpace: 'nowrap' }}>
                {eliminated ? 'Out' : label}
            </Typography>
            <Typography
                component="p"
                sx={{
                    fontFamily: mono,
                    fontVariantNumeric: 'tabular-nums',
                    fontWeight: 600,
                    fontSize: '1.5rem',
                    lineHeight: 1,
                    whiteSpace: 'nowrap',
                    color: eliminated ? colors.muted : colors.ink,
                    textDecoration: eliminated ? 'line-through' : 'none',
                }}
            >
                {formatTokens(balance)}
            </Typography>
        </Box>
    );
}
